import AlphaHelpers from '../../abstracts/classes/alpha-helpers'
import AlphaModule from '../../abstracts/classes/alpha-module'

export default class ExitOverlay extends AlphaModule {
  constructor(...args) {
    super(...args)

    const config = this.getConfig()

    this._exitOverlayEl = document.querySelector(config.exitOverlaySelector)
    this._modalClass = null
  }

  getName() {
    return 'exitOverlay'
  }

  getDependencies() {
    return {
      bsModal: {}
    }
  }

  getDefaultConfig() {
    const attrName = AlphaHelpers.getAlphaAttributeName('required-modules')

    return {
      exitOverlaySelector: `[${attrName}*="${this.getName()}"].modal-block`,
      localStorage: {
        keyFormat: 'exit-overlay-%id%-shown',
        expiry: AlphaHelpers.getTimeConstants().dayInMilliseconds
      }
    }
  }

  _onLoad() {
    super._onLoad()

    if (this._canShowExitOverlay()) {
      this._handleExitOverlay()
    }
  }

  _handleExitOverlay() {
    const exitOverlayEl = this.getExitOverlayElement()
    if (exitOverlayEl) {
      const bsModalModule = this._getManager().getModule('bsModal')
      if (bsModalModule) {
        this._modalClass = bsModalModule.getModalClass()
        const modal = this.getExitOverlayModalInstance(exitOverlayEl)
        if (modal) {
          const mouseOut = (e) => {
            // double check if exit overlay can still be displayed (it might have changed since page load)
            let removeEventListener = false
            if (this._canShowExitOverlay(exitOverlayEl)) {
              if (this._isExitAction(e)) {
                modal.show()

                // mark exit overlay as shown for X milliseconds, based on config (1 day per default)
                const key = this._getLocalStorageKey(exitOverlayEl)
                AlphaHelpers.setLocalStorageItemWithExpiry(key, true, this._getExpiry())
                removeEventListener = true
              }
            } else {
              removeEventListener = true
            }

            // remove listener for further calls
            if (removeEventListener) {
              document.removeEventListener('mouseout', mouseOut)
            }
          }

          document.addEventListener('mouseout', mouseOut)
        }
      }
    }
  }

  _isExitAction(e) {
    const clientYOffset = 10

    return !e.toElement && !e.relatedTarget && e.clientY < clientYOffset
  }

  _canShowExitOverlay(exitOverlayEl = null) {
    exitOverlayEl = this._maybeSetExitOverlayElement(exitOverlayEl)
    if (exitOverlayEl === null) {
      return false
    }

    const key = this._getLocalStorageKey(exitOverlayEl)

    return AlphaHelpers.getLocalStorageItemWithExpiry(key) === null && !exitOverlayEl.classList.contains('show')
  }

  _maybeSetExitOverlayElement(exitOverlayEl = null) {
    if (exitOverlayEl === null) {
      exitOverlayEl = this.getExitOverlayElement()
    }

    return exitOverlayEl
  }

  _getLocalStorageKey(exitOverlayEl = null) {
    exitOverlayEl = this._maybeSetExitOverlayElement(exitOverlayEl)

    return this.getConfig().localStorage.keyFormat.replace('%id%', exitOverlayEl.id)
  }

  _getExpiry() {
    return this.getConfig().localStorage.expiry
  }

  _getModalClass() {
    return this._modalClass
  }

  getExitOverlayElement() {
    return this._exitOverlayEl
  }

  getExitOverlayModalInstance(exitOverlayEl = null) {
    exitOverlayEl = this._maybeSetExitOverlayElement(exitOverlayEl)
    const modalClass = this._getModalClass()

    return modalClass ? modalClass.getOrCreateInstance(exitOverlayEl) : null
  }
}
